import { ApiUtil } from '@/shared/api';

export const reportApi = {
    // 학생공통 리스트 조회

    /** 평가 리포트 요약 조회 ( /tch/report/eval/result/detail/summary ) */
    getReportEvalReviewSummary: (param: API.EvalReviewSummary.Req) => {
        return ApiUtil.get<API.EvalReviewSummary.Res>(
            '/tch/report/eval/result/detail/summary',
            param
        );
    },

    /** 평가 결과 조회(자세히 보기) > 목록 ( /tch/report/eval/result/detail/list ) */
    getReportEvalDetailList: (param: API.ReportEvaluationDetailList.Req) => {
        return ApiUtil.get<API.ReportEvaluationDetailList.Res>(
            '/tch/report/eval/result/detail/list',
            param
        );
    },

    /** 평가 결과 조회(자세히 보기) > 학생 ( /tch/report/eval/result/detail/stnt ) */
    getReportEvalDetailStnt: (param: API.ReportEvaluationDetailStnt.Req) => {
        return ApiUtil.get<API.ReportEvaluationDetailStnt.Res>(
            '/tch/report/eval/result/detail/stnt',
            param
        );
    },

    /**
     * 평가 결과 조회(자세히 보기) > 모듈 ( /tch/report/eval/result/detail/mdul )
     */
    getReportEvalDetailMdul: (param: API.ReportEvaluationDetailMdul.Req) => {
        return ApiUtil.get<API.ReportEvaluationDetailMdul.Res>(
            '/tch/report/eval/result/detail/mdul',
            param
        );
    },

    /** 제출 이후, 학생의 평가결과 상세 정보를 구한다. (/stnt/eval/result-info) */
    getStntEvalResutInfo: (param: API.StntEvlResultInfo.Req) => {
        return ApiUtil.get<API.StntEvlResultInfo.Res>('/stnt/eval/result-info', param);
    },

    /** 평가 결과 배점 수정 ( /tch/report/eval/result/modi/score ) */
    postReportEvalModiScore: (param: API.ReportEvaluationModifyScore.Req) => {
        return ApiUtil.post<API.ReportEvaluationModifyScore.Res>(
            '/tch/report/eval/result/modi/score',
            param
        );
    },

    /** 평가 결과 학생 피드백 ( /tch/report/eval/result/detail/stnt/fdb/mod ) */
    postReportEvalFdbMod: (param: API.ReportEvaluationFdbModify.Req) => {
        return ApiUtil.post<API.ReportEvaluationFdbModify.Res>(
            '/tch/report/eval/result/detail/stnt/fdb/mod',
            param
        );
    },

    // 학생 개별 조회

    getReportEvalResultDetail: (param: API.StntEvalResultDetail.Req) => {
        // 평가 결과 조회(자세히 보기)
        return ApiUtil.get<API.StntEvalResultDetail.Res>(
            '/tch/stnt-srch/report/eval/result/detail',
            param
        );
    },

    // 리포트 공통

    /**
     * 평가 리포트 공개 ( /tch/report/eval/open )
     */
    postReportEvalOpen: (param: API.ReportEvaluationOpen.Req) => {
        return ApiUtil.post<API.ReportEvaluationOpen.Res>('/tch/report/eval/open', param);
    },

    /**
     * 평가 리포트 수정반영 ( /tch/report/eval/result/appl/score )
     */
    postReportEvalApplScore: (param: API.ReportEvaluationApplScore.Req) => {
        return ApiUtil.post<API.ReportEvaluationApplScore.Res>(
            '/tch/report/eval/result/appl/score',
            param
        );
    },

    /* 학생 리포트 */

    getStntReportEvalResultDetail: (param: API.StntEvalResultDetail.Req) => {
        // 평가 결과 조회(자세히 보기)
        return ApiUtil.get<API.StntEvalResultDetail.Res>('/stnt/report/eval/result/detail', param);
    },
};
